module.exports = __webpack_public_path__ + "dist/assets/img/N.f8b64dd2.svg";